import { render, staticRenderFns } from "./GlobalAlertDialog.vue?vue&type=template&id=890e693c&"
import script from "./GlobalAlertDialog.vue?vue&type=script&lang=ts&"
export * from "./GlobalAlertDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports